import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelPayment } from '@/lib/api';

export function useCancelPayment(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => cancelPayment(id),
    onSuccess: (updatedPayment) => {
      queryClient.setQueryData(['payments', id], updatedPayment);
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
  });
}
